// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: 'false',
  Auth: {
    region: 'us-east-1',
    userPoolId: 'us-east-1_OVFjUwHXP',
    userPoolWebClientId: '1ol11dkmo5696fg8gb4pq05eoq'
  },
  sso_issuers: [
    {
      redirect_uri: 'https://login-qa.vistana.com/sso/authenticate',
      homepage_uri: 'https://login-qa.vistana.com',
      logout_uri: 'https://login-qa.vistana.com/sso/logout',
      logout_endpoint: 'https://login-qa.vistana.com/sso/logout'
    }
  ],

  vistana_baseurl: 'https://qa.vistana.com',
  idp_baseurl: 'https://login-qa.vistana.com',
  api_baseurl: 'https://api-qa.vistana.com',
  api_key: 'qsh878drjwnvky34j8f9599p',
  contactUs: 'https://www.vistana.com/contact-us',
  localization: 'false',
  title: 'Vistana Signature Experience',
  analytics: '//assets.adobedtm.com/72eef91a8bc6/b6d66cd43a1d/launch-ad6cc004e375-development.min.js',
  ping_companyId: '102eff72-5b86-43e9-be7c-8d991c52bd79',
  ping_skApiKey: '7baf1cf289e53e3575345fcc1659f1ebcb046c88eaf2ba24b425d9f4f0060a8127babaaf76cbcef91cb41c2a773d231a0928913f6eb61dc3598c242757942f60a54d6fc09da80557f6bc7a8a15672fbbd33f529dafb71f333b78799510f284f5f88f042b4fb67892f7ade9bc254cfffea0067a6e8f7fdab72f31c6fe30c4dc97',
  ping_login_flow_policyId: '21e9e8fa3493d8f87561430b747fc82e',
  ping_manage_account_flow_policyId: '275ea549a1b2bf61ee55187dfdc9dd76',
  ping_challenge_flow_policyId: 'f1d0b7b32923f74e1eddc973bd67c47e'
};


/*
 * In development mode, to ignore zone related error stack frames such as
 * `zone.run`, `zoneDelegate.invokeTask` for easier debugging, you can
 * import the following file, but please comment it out in production mode
 * because it will have performance impact when throw error
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
